import { isMonthYearInRange, isMonthYearBeforeOrEqual, isMonthYearAfterOrEqual, MonthYear } from '@common/neo.tax';

export const isOptionDisabled = (currentMonthYear: MonthYear, min?: MonthYear, max?: MonthYear): boolean => {
  if (min && max) {
    return !isMonthYearInRange(currentMonthYear, min, max);
  }
  if (min) {
    return !isMonthYearAfterOrEqual(currentMonthYear, min);
  }
  if (max) {
    return !isMonthYearBeforeOrEqual(currentMonthYear, max);
  }
  return false;
};
